import type { Schemas } from "#shopware";

type NavigationElement = Schemas["Category"] & {
  activeClass?: boolean;
};

const _useBrands = () => {
  const { navigationElements } = useNavigation();
  const { activeCategoryId } = useActiveCategory();

  const findActiveBrand = (elements: NavigationElement[]) => {
    if (!activeCategoryId.value) {
      return elements[0];
    }
    for (const element of elements) {
      if (
        element.id === activeCategoryId.value ||
        hasActiveChild(element.children || [])
      ) {
        return element;
      }
    }
    return elements[0];
  };

  const hasActiveChild = (children: NavigationElement[]): boolean => {
    return children.some(
      (child) =>
        child.id === activeCategoryId.value ||
        hasActiveChild(child.children || [])
    );
  };

  const brands = computed(() => {
    return navigationElements.value;
  });

  const activeBrand = computed(() => {
    if (!activeCategoryId.value) return defaultBrand.value;
    return findActiveBrand(brands.value || []);
  });

  const subBrands = computed(() => {
    return brands.value?.filter((brand) => brand.id !== activeBrand.value?.id);
  });

  const defaultBrand = computed(() => brands.value?.[0] ?? null);

  const isSubBrand = computed(() => {
    return activeBrand.value?.id !== defaultBrand.value?.id;
  });

  return {
    findActiveBrand,
    subBrands,
    brands,
    activeBrand,
    defaultBrand,
    activeCategoryId,
    isSubBrand,
  };
};

export const useBrands = createSharedComposable(_useBrands);
